module.exports = __webpack_public_path__ + "static/antd-datepicker-footer-ea1df098565332532a7ba636afda8ad6.png";